__turbopack_context__.v({
  "root": "ServiceLIst-module-scss-module__1dcoXG__root",
  "slide": "ServiceLIst-module-scss-module__1dcoXG__slide",
});
